import { TableColumn } from './types';

export const getHiddenColumnsList = (columns: TableColumn[]): string[] =>
  columns.filter((column) => !column.isVisible).map((column) => `${column.id}`);

export const canRenderRow = (
  item: number,
  pageSize: number,
  currentPage: number,
  isServerPagination: boolean = false,
): boolean => {
  const startRow = pageSize * currentPage;
  const endRow = startRow + pageSize;

  if (isServerPagination) {
    return true;
  }

  return item >= startRow && item < endRow;
};
